import Quill from 'quill'
import VueQuillEditor from 'vue-quill-editor' //TODO: it should be replaced with a new package which works with on Vue 3

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import { ImageDrop } from 'quill-image-drop-module'
//import ImageResize from 'quill-image-resize-module'

Quill.register('modules/imageDrop', ImageDrop)
//Quill.register('modules/imageResize', ImageResize)

export { VueQuillEditor }
